import {BehaviorSubject, from, Subject} from 'rxjs';
import {map, startWith, switchMap} from 'rxjs/operators';
import {strategyApi} from '@px/api/strategy';
import {userInfo$} from './user';

export const isStrategy$ = new BehaviorSubject<boolean>(false);

export const gridTvLines$ = new BehaviorSubject<GridTvLine[]>([]);

export const tipId$ = new BehaviorSubject<string>('');

export const availableStrategySymbolQuery$ = new Subject<StrategyType>();

export const availableSymbolState$ = new BehaviorSubject<{loading: boolean; list: string[]}>({
  loading: true,
  list: [],
});

availableStrategySymbolQuery$
  .pipe(
    switchMap((strategyType) => strategyApi.availableSymbol({strategyType})),
    map((res) => {
      const list = (res.data || []).map((e) => e.symbol);
      return {
        loading: false,
        list,
      };
    })
  )
  .subscribe((v) => availableSymbolState$.next(v));

export const strategyVisible$ = userInfo$.pipe(
  map((userInfo) => userInfo.isMain),
  startWith(false)
);

export const strategyTab$ = new BehaviorSubject<'Standard' | 'Strategy'>('Standard');

export const strategyType$ = new BehaviorSubject<'Home' | 'Grid' | 'Martingale' | 'Signal' | 'SpotGrid'>('Home');

export const strategyOrderType$ = new BehaviorSubject<'Recommend' | 'Manual'>('Recommend');

export const orderViewType$ = new BehaviorSubject<'Grid' | 'Martingale' | 'Signal' | 'SpotGrid'>('Grid');

export const orderViewStatus$ = new BehaviorSubject<'Active' | 'History'>('Active');

interface Result<T> {
  loading: boolean;
  success: boolean;
  data: T;
}

export const openQuery$ = new Subject();
export const openState$ = new BehaviorSubject<Result<any[]>>({loading: true, success: true, data: []});
openQuery$.pipe(switchMap((query: any) => useLoading(strategyApi.openList(query)))).subscribe((res: any) => {
  openState$.next(res.loading ? res : {loading: false, success: true, data: res?.data || []});
});

export const historyQuery$ = new Subject();
export const historyState$ = new BehaviorSubject<Result<any[]>>({loading: true, success: true, data: []});
historyQuery$.pipe(switchMap((query: any) => useLoading(strategyApi.historyList(query)))).subscribe((res: any) => {
  historyState$.next(res.loading ? res : {loading: false, success: true, data: res?.data?.rows || []});
});

export const mHistoryQuery$ = new Subject();
export const mHistoryState$ = new BehaviorSubject<Result<any[]>>({loading: true, success: true, data: []});
mHistoryQuery$.pipe(switchMap((query: any) => useLoading(strategyApi.martinHistoryList(query)))).subscribe((res: any) => {
  mHistoryState$.next(res.loading ? res : {loading: false, success: true, data: res?.data?.rows || []});
});

export const recommendQuery$ = new Subject();
export const recommendState$ = new BehaviorSubject<Result<any[]>>({loading: true, success: true, data: []});
recommendQuery$.pipe(switchMap((query: any) => useLoading(strategyApi.recommendList(query)))).subscribe((res: any) => {
  recommendState$.next(res.loading ? res : {loading: false, success: true, data: res?.data || []});
});

function useLoading(request, initData: {loading: boolean; data?: any; success?: boolean; isInit?: boolean} = {loading: true, data: [], success: false, isInit: true}) {
  return from(request).pipe(startWith(initData));
}
